import { GoogleBusinessConnectionOptions } from '../../../../../modals/live-orders/LiveOrdersDrawer';

export default {
  titles: {
    disable: 'Voulez-vous vraiment désactiver les commandes en direct ?',
    enable: 'Voulez-vous vraiment activer les commandes en direct ?',
  },
  form: {
    is_google_business_available: {
      label: 'Google Business disponible',
    },
    is_smart_pricing_configured: {
      label: 'Prix moins chers que Lieferando, Wolt, Uber',
    },
    is_flyers_package_sent: {
      label: 'Flyer promotionnel envoyé',
    },
    is_menu_fully_configured: {
      label: 'Tous les articles du menu disponibles',
    },
    has_offers_on_competitor_platforms: {
      label: 'Le restaurant propose-t-il des offres sur Wolt, Uber, Lieferando (hors offre de livraison gratuite) ?',
    },
    is_instagram_story_shared: {
      label: 'Story Instagram partagée avec le propriétaire',
    },
    is_order_system_connected_to_website: {
      label: 'Site Foodamigos connecté OU bouton de commande en ligne ajouté sur le site du restaurant',
    },
    google_business_connected_by: {
      label: "Comment avons-nous obtenu l'accès au profil Google Business ?",
      options: {
        [GoogleBusinessConnectionOptions.SalesManagerOverEmail]:
          'Le responsable commercial a invité google@foodamigos.io',
        [GoogleBusinessConnectionOptions.SalesManagerOverPhone]:
          'Le responsable commercial a envoyé la première demande lui-même depuis le téléphone du propriétaire',
        [GoogleBusinessConnectionOptions.OnboardingManagerOverEmail]:
          "Le responsable onboarding a demandé le profil Google Business (le SM n'a pas invité ni demandé l'accès)",
      },
    },
  },
  labels: {
    successful_launch:
      'Pour garantir un lancement réussi, veuillez examiner et traiter les points ouverts suivants. Vérifier \n' +
      "ces informations permettra d'éviter d'éventuels problèmes une fois le restaurant en ligne.",
    check_errors: 'Vérifiez les erreurs pour garantir un bon lancement du restaurant.',
    checkbox_confirmation: "Je confirme avoir examiné les erreurs et consens à l'activation de ce restaurant.",
  },
  buttons: {
    check_error: "Vérifier l'erreur",
    confirm_and_activate: 'Confirmer et activer',
    cancel: 'Annuler',
    yes: 'Oui',
    no: 'Non',
  },
  errors: {
    name: {
      title: 'Pas de caractères arabes, chinois, etc. dans le nom de la boutique',
      description: 'Le nom de la boutique en ligne contient des caractères non latins',
    },
    logo_url: {
      title: 'Logo',
      description: 'Le logo a été téléversé sur la boutique en ligne',
    },
    pictures: {
      title: 'Image de galerie',
      description: '≥ 1 image de galerie disponible en boutique',
    },
    menu_uploaded: {
      title: 'Menu téléversé',
      description: '≥ 1 menu disponible',
    },
    opening_hours: {
      title: "Horaires d'ouverture",
      description: "≥ 1 horaire d'ouverture ajouté",
    },
    address: {
      title: 'Adresse du restaurant',
      description: 'Rue, ville, code postal saisis',
    },
    upsell_items: {
      title: 'Articles upsell',
      description: '≥ 3 articles upsell sélectionnés',
    },
    master_promo_code: {
      title: 'Code promo principal',
      description: 'Le code promo principal est disponible',
    },
    flyers_ordered: {
      title: 'Flyers commandés',
      description: '≥ 1 lot de flyers commandé',
    },
    test_orders: {
      title: 'Commande test envoyée',
      description: '≥ 1 commande test effectuée',
    },
    stripe_billing: {
      title: 'Compte Stripe',
      description: 'Compte Stripe connecté',
    },
    payments_configured: {
      title: 'Paiements configurés',
      description: 'Le partenaire a connecté un fournisseur de paiement — requis avant la mise en ligne',
    },
    adyen_merchant_account: {
      title: 'Compte marchand Adyen',
      description: 'Un compte marchand actif pour le pays de ce restaurant — requis pour les tarifs carte domestiques',
    },
    payment_rail_covers_country: {
      title: 'Le circuit de paiement couvre le pays',
      description: 'Les comptes de paiement du partenaire peuvent traiter le pays de ce restaurant',
    },
    identity: {
      title: 'Identité du restaurant',
      description: 'Le type de restaurant et la cuisine ont été définis',
    },
    storefront: {
      title: 'Vitrine créée et domaine connecté',
      description: 'Uniquement si le restaurant souhaite utiliser notre site',
    },
    google_business: {
      title: 'Google Business',
      description: 'Google Business connecté',
    },
    billing_payment_method: {
      title: 'Moyen de paiement',
      description: 'Ajoutez un moyen de paiement pour que FoodAmigos puisse facturer ce restaurant mensuellement.',
    },
    billing_license: {
      title: 'Licence',
      description: "Ce restaurant a besoin d'un Partner Plan avant de pouvoir être mis en ligne.",
    },
    business_name: {
      title: "Nom de l'entreprise / du restaurant",
      description:
        "Le nom affiché dans les conditions d'utilisation et la politique de confidentialité a été enregistré",
    },
    payment_method: {
      title: 'Paiements en espèces ou en ligne',
      description:
        'Le paiement en espèces à la livraison ou au retrait est activé, ou les paiements en ligne sont vérifiés',
    },
    stripe_processing_fee: {
      title: 'Frais de traitement',
      description: 'Le partenaire a défini ses frais de traitement Stripe ou confirmé une marge de 0 %',
    },
  },
};
